module.exports = __webpack_public_path__ + "img/btn3.e6771440.png";